<!-- 文本消息默认模版 -->
<template>
  <div v-modal-show="display">
    <div @click="closeModal()" class="mask"></div>
    <section class="M_wrap M_notice M_style M_btn_0 M_style_2 M_style_2_h">
      <div class="M_cont">
        <p class="M_title T_18_25 T_b"><span>{{ msgTitle }}</span></p>
        <div class="T_12_16 T_b" v-html="msgContent"></div>
        <!-- <p class="T_12_16 T_b M_m_time">{{ msgInfo.createTimeFormat }}</p> -->
      </div>
      <a class="M_close I_n" @click="closeModal()"></a>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    showMsgModal: {
      type: Boolean,
      default: false
    },
    msgContent: {
      type: String
    },
    msgTitle: {
      type: String
    },
    closeBack: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      display: false
    }
  },
  mounted () {
    let _this = this
    setTimeout(function () {
      _this.display = _this.showMsgModal
    }, 10)
  },
  created () {
  },
  methods: {
    closeModal: function () {
      this.closeBack()
    }
  }
}
</script>

<style scoped src="@v2/assets/css/modals.module.css"></style>



// WEBPACK FOOTER //
// RealNameCouponModal.vue?8e836dd8